module.exports = __webpack_public_path__ + "img/126-botswana.d409478f.svg";